module.exports = __webpack_public_path__ + "static/media/js-square.3fa7f140.svg";